<template>
  <div>
    <div v-if="detail_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap>
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>

      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 class="text-xs-right" mt-3>
          <v-menu offset-y>
            <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button">
              <router-link to="/announcements" class="white--text">
                <v-icon color="#bbbbc6" class="white--text">list</v-icon>
                &nbsp&nbsp News List
              </router-link>
            </v-btn>
          </v-menu>
          <v-card>
            <v-form
                id="update_news"
                @submit.prevent="validateBeforeSubmit('updateNews')"
                data-vv-scope="updateNews"
                ref="news_form"
                v-model="valid"
            >
              <v-card-text>
                <v-container fluid grid-list-md
                             style="margin-left:4px;line-height: 20px;text-align: -webkit-left;padding-bottom: 10px;">
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg4>
                      <label>Commute Medium</label>
                      <v-autocomplete
                          :items="medium_types"
                          name="Commute Medium"
                          label="Select medium"
                          v-model="news_detail.commute_medium_id"
                          return-object
                          item-text="name"
                          item-value="id"
                          solo flat
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <label>City:</label>

                      <v-autocomplete
                          :items="cityList"
                          name="CityName"
                          label="Select City"
                          v-model="news_detail.city_id"
                          item-text="name"
                          item-value="id"
                          v-validate="'required'"
                          :error-messages="errors.collect('updateNews.CityName')"
                          solo flat>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap style="display: flex; align-items: center;">
                    <v-flex xs12 sm8 md6 lg6>
                      <label>Source URL </label>
                      <v-text-field
                          name="Source URL"
                          v-model="news_detail.source_url"
                          label="Source URL"
                          solo flat
                          clearable
                          :error-messages="errors.collect('updateNews.Source URL')"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 md6 lg3 style="margin-top: -11px;">
                      <v-btn color="primary" @click="autoCreateNew()"
                             :disabled="(news_detail.source_url == '' || news_detail.source_url == null)">Auto Create
                        News
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Title </label>
                      <v-text-field
                          name="Title"
                          v-model="news_detail.title"
                          label="Title"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('updateNews.Title')"
                          clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Description: </label>
                      <v-textarea
                          name="Description"
                          v-model="news_detail.description"
                          rows="2"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('updateNews.Description')"
                          clearable
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <!--                         <label>Source Name </label>-->
                      <!--                         <v-text-field-->
                      <!--                             name="Source URL"-->
                      <!--                             v-model="news_detail.source_name"-->
                      <!--                             label="Source Name"-->
                      <!--                             solo flat-->
                      <!--                             clearable-->
                      <!--                         ></v-text-field>-->

                      <v-combobox
                          :items="news_sources"
                          name="Source"
                          label="Select Source"
                          v-model="news_detail.source_name"
                          item-text="name"
                          item-value="name"
                          solo flat
                          :return-object="false"
                      >
                      </v-combobox>
                    </v-flex>
                  </v-layout>

                  <!--                <v-layout row wrap>-->
                  <!--                  <v-flex xs12 md6 lg8>-->
                  <!--                    <label>Image URL </label>-->
                  <!--                    <v-text-field-->
                  <!--                        name="Source URL"-->
                  <!--                        v-model="news_detail.image_url"-->
                  <!--                        label="Image URL"-->
                  <!--                        solo flat-->
                  <!--                        clearable-->
                  <!--                    ></v-text-field>-->
                  <!--                    <input type="file"  name="previewImage" accept="*/*" @change=uploadImage v-validate="'ext:jpg,jpeg,png'" solo flat /><br>-->
                  <!--                    <span style="font-size: 11px;">(Allowed file types: JPG,JPEG,PNG)</span>-->
                  <!--                    <div class="red&#45;&#45;text pt-3" v-if="errors.collect('news_detail.previewImage').length">-->
                  <!--                      {{ errors.collect('news_detail.previewImage')[0] }}-->
                  <!--                    </div>-->
                  <!--                  </v-flex>-->
                  <!--                </v-layout>-->

                  <v-layout row wrap>
                    <v-flex xs12 sm12 md8 lg8 style="display: flex; flex-wrap: wrap; padding-bottom: 23px !important;">
                      <v-flex xs12 sm6 md6 lg6 style="padding-bottom: 15px !important;">
                        <label>Upload Image</label>
                        <input type="file" name="image_path" id="image_path" class="form-control flatpickerCSS2"
                               v-on:change="uploadImage" v-validate="'ext:jpg,jpeg,png'">
                      </v-flex>

                      <v-flex xs12 sm12 md6 lg6 row wrap class="ImageDisplay" v-if="news_detail.image_url != null"
                              style="flex-wrap: wrap; flex-direction: column; align-items: center; align-content: space-around;">

                        <v-flex xs12 sm12 md12 lg12 v-if="oldImage"
                                style="height: auto; width: auto;">
                          <img :src="storage_path() + news_detail.image_url"
                               class="figure-img img-fluid rounded"
                               style="max-height:100px; max-width: 100%;">
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 v-else>
                          <img :src="news_detail.image_url"
                               class="figure-img img-fluid rounded"
                               style="max-height:100px; max-width: 100%;">
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-btn icon @click="clearImage()">
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-flex>

                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md12 lg8 style="display: flex;">
                      <v-flex xs12 md4 lg4>
                        <v-checkbox
                            v-model="news_detail.is_scheduled"
                            label="Is Scheduled"
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12 md8 lg8 v-if="news_detail.is_scheduled == 1">
                        <label>Scheduled At: </label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              label="Scheduled At"
                              v-model="news_detail.scheduled_at"
                              :config="config_commute_update" name="Scheduled_At"
                              placeholder="Schedule Date & Time" v-validate="'required'"
                              :error-messages="errors.collect('updateNews.Scheduled_At')"
                          />
                        </div>
                      </v-flex>
                    </v-flex>
                  </v-layout>


                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Body: </label>
                      <!--                    <vue-editor-->
                      <!--                        name="news Body"-->
                      <!--                        v-model="news_detail.body"-->
                      <!--                        label="news Body"-->
                      <!--                        solo flat-->
                      <!--                    ></vue-editor>-->

                      <quill-editor ref="myQuillEditor"
                                    name="News_Body"
                                    :value="news_detail.body"
                                    :options="quillOptions"
                                    label="news Body"
                                    solo flat @input="updateBody"/>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" small :disabled="news_detail.type == '' || news_detail.title == ''||
                news_detail.description == '' || (news_detail.is_scheduled == true && news_detail.scheduled_at == '')">
                  Update
                </v-btn>
                <v-btn flat small to="/news">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog
          v-model="status_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to {{ this.announcement_status }} this announcement?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small @click="updateStatus()">OK</v-btn>
              <v-btn color="black" small flat type="reset" @click="status_model = false">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="delete_announcement"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete announcement?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="deleteAnnouncement()">Delete</v-btn>
              <v-btn small color="black" flat type="reset" @click="delete_announcement = !delete_announcement">Cancel
              </v-btn>

            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.display"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.display = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
// import { VueEditor, Quill } from "vue2-editor";
import {quillEditor} from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';

// const Block = Quill.import("blots/block");
// Block.tagName = "DIV";
// Quill.register(Block, true);
export default {
  created() {
  },
  computed: {
    // workspaceRequestCode:function(){
    //  return this.news_detail.office_id.name + '/'+ this.news_detail.tower_id.name + '/' + this.news_detail.wing_id.name +'/'+this.news_detail.type+'/'+this.news_detail.number;
    // }
  },
  components: {
    // VueEditor,
    flatPickr, quillEditor
  },
  watch: {
    "news_detail.is_scheduled": function (val) {
      if (val == false) {
        this.news_detail.scheduled_at = "";
      }
    },
    "news_detail.body": function (val) {
      if (val == '' || val != null) {
        setInterval(this.handleTextChange, 1000);
      }
    }
  },
  methods: {
    strippedContent: function (string) {
      if (string !== undefined && string !== null) {
        return string.replace(/<\/?[^>]+>/ig, " ");
      }

    },
    uploadImage(e) {
      this.oldImage = '';
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.news_detail.image_url = e.target.result;
      };
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },


    getNewsDetails: function () {
      this.detail_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/news/` +
              this.$route.params.id, {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.news_detail = response.data.news;
              this.previous_status = response.data.news.status;
              // this.news_detail.medium_types.id = this.news_detail.commute_medium_id;
              this.news_detail.image_url = response.data.news.image_url;
              this.oldImage = this.news_detail.image_url;
              this.detail_loader = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    updateNews: function () {
      this.detail_loader = true;
      let new_news = Object.assign({}, this.news_detail);

      if (typeof this.news_detail.commute_medium_id === 'number') {
        new_news.commute_news_ID = this.news_detail.commute_medium_id;
      } else {
        new_news.commute_news_ID = this.news_detail.commute_medium_id.id;
      }
      new_news.previewImage = this.news_detail.image_url;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-news`, new_news, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          this.$router.push({name: 'newsList'});
          this.detail_loader = false;
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
        } else if (response.data.status == 2) {
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
          this.$validator.reset();
          // this.$refs.announcement_form.reset();

        } else {
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
        }

      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.detail_loader = false;
      });

    },

    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/commute-mediums`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.medium_types = response.data.types;
            }

          })
    },
    getSources: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/news-sources`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.news_sources = response.data.list;
            }

          })
    },
    changeStatus: function (value) {
      this.announcement_status = value;
      this.status_model = true;
    },
    updateStatus: function () {
      this.detail_loader = true;

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/change-status`, {
        announcement_id: this.$route.params.id,
        status: this.announcement_status
      }, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          this.detail_loader = false;
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.status_model = false;
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
          this.getTypeList();
          this.getAnnouncementDetails();
        }
        if (response.data.status == 2) {
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.status_model = false;
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
        }

      }).catch((error) => {

      }).finally(() => {

      });
    },

    deleteAnnouncement: function () {
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-announcement`, {announcement_id: this.$route.params.id}, {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.delete_announcement = false;
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
          this.$router.push('/announcements');
        }


      }).catch((error) => {

      }).finally(() => {

      });
    },
    clearImage() {
      this.news_detail.image_url = null;
      $('#image_path').val('');
    },
    autoCreateNew() {
      this.startLoading();
      axios.get(`https://hook.us1.make.com/ckdczp4u3uq9k87pf6j1u7eqj4j7uixx?url=` + this.news_detail.source_url,
          {'Content-Type': 'application/x-www-form-urlencoded'})
          .then((response) => {
            if (response) {
              this.stopLoading();
              this.news_detail.title = JSON.parse(response.data.title_desc).title;
              this.news_detail.description = JSON.parse(response.data.title_desc).description;
              this.news_detail.body = JSON.parse(response.data.body).summary;
            }
          }).catch((error) => {
        this.stopLoading();
        this.snackBar.message = "Something went wrong.";
        this.snackBar.display = true;
        console.log(error);
      })
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    handleTextChange() {
      if (this.news_detail.body != null || this.news_detail.body == '') {
        const containsImages = this.news_detail.body.includes('<img');
        if (containsImages) {
          const imageData = this.news_detail.body.match(/<img[^>]+src="([^">]+)"/g);


          imageData.forEach((element) => {
            const srcMatch = element.match(/src="([^"]+)"/);

            let Image_data = srcMatch[1];
            if (Image_data.startsWith('data:image/png;base64,') ||
                Image_data.startsWith('data:image/jpg;base64,') ||
                Image_data.startsWith("data:image/jpeg;base64,")) {
              axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-image-to-azure`, {Image_data})
                  .then(response => {
                    if (response.data.status == 1) {

                      this.image_flag = 1;
                      this.azure_image_path = response.data.data;

                      const new_UrL = process.env.VUE_APP_AZURE_STORAGE_URL +
                          process.env.VUE_APP_AZURE_STORAGE_CONTAINER + '/' + this.azure_image_path;

                      const escapedOldSrc = this.escapeRegExp(srcMatch[1]);
                      const regex = new RegExp(`<img src="${escapedOldSrc}"`, 'g');
                      this.news_detail.body =
                          this.news_detail.body.replace(regex, `<img src="${new_UrL}"`);

                    }
                  })
            }
          });
        }
      }
    },
    updateBody(value) {
      this.$set(this.news_detail, 'body', value);
    },
    updateBodyTag(value) {
      this.news_detail.body = this.news_detail.body.replace(/<img[^>]+src="([^">]+)"/g,
          `<img src="${value}"`);
    },
    getCityList() {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    }

  },
  data: () => {
    return {
      status_model: false,
      delete_announcement: false,
      announcement_status: '',
      news_detail: {},
      detail_loader: false,
      valid: false,
      medium_types: [],
      local_lines: [],
      train_codes: [],
      auth_user: {
        roles: [{}]
      },
      workspaceRequestCode: "",
      snackBar: {
        display: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
      news_sources: [],
      previous_status: '',
      oldImage: '',
      config_commute_update: {
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
        maxDate: moment().add(45, 'days').format('YYYY-MM-DD')
      },
      quillOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'direction': 'rtl'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            ['clean'],
            ['image']
          ]
        },
        theme: 'snow'
      },
      azure_image_path: '',
      cityList: [],
    };
  },

  mounted() {
    this.getCityList();
    this.getNewsDetails();
    this.getTypeList();
    this.getSources();
  },
};
</script>


